import React from 'react';

export const ID_LIST = [
  {
    itemId: 'P22XA1148401',
    skuId: 'SP22XA1148401E',
    productsName: 'customized-pillow-with-photo'
  },
  {
    itemId: 'P22XA1148401',
    skuId: 'SP22XA1148401F',
    productsName: 'customized-pillow-with-photo'
  },
  {
    itemId: 'P22XA1148401',
    skuId: 'SP22XA1148401Q',
    productsName: 'customized-pillow-with-photo'
  },
  {
    itemId: 'P22XA1148401',
    skuId: 'SP22XA1148401R',
    productsName: 'customized-pillow-with-photo'
  },
  {
    itemId: 'P22XJ2233102',
    skuId: 'SP22XJ2233102U',
    productsName: 'customized-keychain'
  },
  {
    itemId: 'P22Y71956261',
    skuId: 'SP22Y71956261U',
    productsName: 'customized-mini-pillow-keychain'
  },
];
